import { css } from "@emotion/core";
import { FONTS } from "shared/styles/base";
import { resetButton } from "shared/styles/mixin";

export const modalCss = css`
    padding: 46px 46px 30px 46px;
    width: 944px;
    margin: 0 auto;
    font-family: ${FONTS.CERA};

    @media (max-width: 768px) {
        width: 90%;
        height: auto;
        padding: 20px;
    }

    &.show-modal {
        animation: none;
        position: fixed;
        top: auto;
        bottom: 32px;
        left: calc(50% - 472px);
        @media (max-width: 768px) {
            bottom: 10px;
            top: auto;
            left: 5%;
        }
    }
`;

export const cookiesContentCss = css`
    .cookies-title {
        height: 20px;
        font-size: 20px;
        font-weight: bold;
        color: #000;
        margin-bottom: 18px;

        @media (max-width: 768px) {
            height: 19px;
            font-size: 16px;
            margin-bottom: 10px;
        }
    }

    .cookies-content {
        font-size: 16px;
        line-height: 1.31px;
        color: #000;

        @media (max-width: 768px) {
            font-size: 14px;
            line-height: 17px;
        }
    }

    a {
        text-decoration: underline;
        color: #fd7685;
    }
`;

export const acceptBtnCss = css`
    ${resetButton}

    width: 204px;
    text-transform: capitalize;
    height: 40px;
    font-family: ${FONTS.CERA};
    float: right;
    padding: 10px;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    color: #d8d8d8;
    background: #000;
    border-radius: 2px;
    cursor: pointer;
    display: block;
    margin-top: 11px;

    @media (max-width: 768px) {
        padding: 11px 0 0 0;
        width: 144px;
        font-size: 14px;
        line-height: 17px;
        margin-top: 14px;
    }
`;
